import React from "react";
import "./header.css";

export default function Header() {
  return (
    <div className="header">
      <a href="./" className="brand-link">
        @sumitranjan52
      </a>
      <div>
        <a href="./" className="menu-link selected">
          Home
        </a>
        <a href="./" className="menu-link">
          Resume
        </a>
        <a href="./" className="menu-link">
          Projects
        </a>
        <a href="./" className="menu-link">
          Contact
        </a>
      </div>
    </div>
  );
}
